module.exports = __webpack_public_path__ + "static/media/12.8d4d7ed2.jpg";